import { useMemo, useEffect, useState } from "react";
import { produce } from "immer";

import "react-datepicker/dist/react-datepicker.css";

import "./style.scss";
import Text from "./fields/Text";
import Select from "./fields/Select";
import MediaUpload from "./fields/MediaUpload";
import Address, { sortJsonArrayAlphabetically } from "./fields/Address";
import Checkbox from "./fields/Checkbox";
import Childrens from "./fields/Childrens";
import Radio from "./fields/Radio";
import Switcher from "./fields/Switcher";
import BloodGroup from "./fields/BloodGroup";
import Style from "../../components/Style";
import BDatePicker from "./fields/BDatePicker";

const RegistrationForm = ({
  loading,
  fields,
  currentItem,
  setCurrentItem = () => {},
  formData = {},
  notice,
  onSubmit,
  error,
  setFormData = () => {},
  styles,
  uniqueId,
  editable = true,
  type = "registration",
  ...props
}) => {
  const isBackend = useMemo(() => window.location.href.includes("wp-admin"), [window.location]);
  const [districtList, setDistrictList] = useState(props.districtList);
  const [thanaList, setThanaList] = useState(props?.thanaList);

  useEffect(() => {
    if (!props.districtList || props.districtList?.length < 1) {
      fetch("https://raw.githubusercontent.com/shehabulislam/bangladesh-geojson/master/bd-districts.json")
        .then((res) => res.json())
        .then((res) => {
          setDistrictList(sortJsonArrayAlphabetically(res.districts));
        });
    }
    if (!props.thanaList || props.thanaList?.length < 1) {
      fetch("https://raw.githubusercontent.com/shehabulislam/bangladesh-geojson/master/bd-upazilas.min.json")
        .then((res) => res.json())
        .then((res) => setThanaList(sortJsonArrayAlphabetically(res)));
    }

    if (type === "application") {
      setFormData(
        produce(formData, (draft) => {
          draft["is_approved"] = true;
        })
      );
    }
  }, []);

  return (
    <>
      <form className={`mmmbaa_r_form ${editable ? "" : "mmm_form_disabled"}`} id={uniqueId} onSubmit={onSubmit}>
        {Array.isArray(fields) &&
          fields.map((field, index) => {
            const { width = "full_width", type, labelPosition = "top", dependencies, name, number_of_column } = field;
            let show = true;
            const dep = dependencies?.split("\n");

            if (dep?.length > 0 && !isBackend) {
              dep.map((item) => {
                const [key, value] = item.split("|");
                if (key && value) {
                  show = formData[key] === value;
                }
              });
            }

            if (!show) {
              return <></>;
            }

            const props = {
              ...field,
              isBackend,
              value: formData[name],
              onChange: (value) => {
                setFormData(
                  produce(formData, (draft) => {
                    draft[name] = value;
                  })
                );
              },
            };

            return (
              <div
                onClick={() => setCurrentItem(index)}
                key={index}
                className={`${width} form_field field_${type} ${number_of_column} ${labelPosition === "left" ? "field_inline" : ""} ${
                  currentItem !== index && isBackend ? "field_not_active" : ""
                } ${name}`}
              >
                {["text", "email", "password"].includes(type) && <Text {...props} />}
                {type === "select" && <Select {...props} />}
                {type === "file" && <MediaUpload {...props} />}
                {type === "date-picker" && <BDatePicker {...props} />}
                {type === "address" && <Address thanaList={thanaList} districtList={districtList} {...props} value={typeof formData[name] === "object" ? formData[name] : null} />}
                {type === "checkbox" && <Checkbox {...props} value={Array.isArray(formData[name]) ? formData[name] : []} />}
                {type === "radio" && <Radio {...props} />}
                {type === "childrens" && (
                  <>
                    <Text
                      {...props}
                      type="number"
                      value={formData["no_of_children"]}
                      onChange={(value) => {
                        setFormData(
                          produce(formData, (draft) => {
                            draft["no_of_children"] = value;
                          })
                        );
                      }}
                    />
                    <Childrens
                      value={Array.isArray(formData["childrens"]) ? formData["childrens"] : [{ name: "" }]}
                      no_of_children={formData["no_of_children"]}
                      onChange={(value) => {
                        setFormData(
                          produce(formData, (draft) => {
                            draft["childrens"] = value;
                          })
                        );
                      }}
                    />
                  </>
                )}
                {type === "switch" && <Switcher {...props} value={Boolean(["null", "false"].includes(formData[name]) ? false : formData[name])} />}
                {type === "blood-group" && <BloodGroup {...props} />}
              </div>
            );
          })}
        {editable && (
          <div className="mmmbaa_button_wrapper">
            <button disabled={loading} className="mmmbaa_submit_button">
              {loading && (
                <svg width={15} className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx={12} cy={12} r={10} stroke="currentColor" strokeWidth={4} />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
              )}{" "}
              {window.location.pathname.includes("/dashboard") ? "Update" : "Submit"}
            </button>
          </div>
        )}
        {/* {type === "application" && (
          <div className="mmmbaa_button_wrapper">
            <button disabled={loading} className="mmmbaa_submit_button">
              {loading && (
                <svg width={15} className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx={12} cy={12} r={10} stroke="currentColor" strokeWidth={4} />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
              )}
              Approve
            </button>
          </div>
        )} */}
      </form>
      {error && (
        <div className="mmmbaa_error_wrapper" id="mmm_notice">
          <p>{error.message || JSON.stringify(error)}</p>
        </div>
      )}
      {notice && (
        <div className="mmmbaa_notice_wrapper">
          <p>{notice}</p>
        </div>
      )}
      <Style styles={styles} uniqueId={uniqueId} />
    </>
  );
};

export default RegistrationForm;
